// NON BREAKING SPACE
export const NBSP = '\u00A0';
export const NULLISH_VALUE = '-';
